import { useCallback } from 'react';
import { useRouter } from 'expo-router';
import { useAuthStore, useAgentStore, useChatInputStore, useCoworkerStore, useModalStore, useModelStore } from '@/store';
import useRequireAuth from '@/hooks/useRequireAuth';

export default function useStartAgentChat() {
  const router = useRouter();
  const requireAuth = useRequireAuth();
  const isPlus = useAuthStore(state => state.user?.flags?.isPlus);
  const { openModal } = useModalStore(state => state.actions);

  return useCallback((agent, { replace = false, source = 'agent_card_quick_chat' } = {}) => {
    if (!agent?.id) return;
    return requireAuth(() => {
      if (agent.flags?.isPlusOnly && !isPlus) {
        openModal('PlusFeatureModal', { feature: 'bots' });
        return false;
      }
      const composer = useChatInputStore.getState();
      const models = useModelStore.getState().models || {};
      const arya = Object.values(models).find(model => model.slug === 'arya');
      // Seed the composer with the bot's saved chat model when it is still
      // usable; the model picker stays free to change it mid-conversation.
      const agentModel = (agent.defaultModelId || agent.defaultModel) ? models[agent.defaultModelId || agent.defaultModel] : null;
      const seedModel = agentModel
        && agentModel.flags?.isEnabled !== false
        && agentModel.flags?.isDeprecated !== true
        && agentModel.capabilities?.output?.hasText === true
        ? agentModel
        : null;
      useAgentStore.getState().addAgents([agent]);
      composer.setContext('new');
      composer.clearInput(true);
      composer.setSelectedModels(seedModel ? [seedModel.id] : (arya ? [arya.id] : []));
      composer.setSelectedAgents([agent.id], { botId: agent.id });
      useCoworkerStore.getState().setComposerMode('chat');
      if (replace) router.replace('/app');
      else router.push('/app');
      return true;
    }, {
      source,
      title: `Sign in to chat with ${agent.name || 'this bot'}`,
      subtitle: 'Create a free account to save your conversations.',
      icon: 'robot',
    });
  }, [isPlus, openModal, requireAuth, router]);
}
